<template>
    <alert-modal
        :title="$t('EXIT_MODAL_TITLE')"
        :superTitle="$t('EXIT_MODAL_SUPER')"
        @close="close"
        class="cz2__exit-modal"
    >
        <div class="cz2__modal-popup__copy">
            {{ $t('EXIT_MODAL_COPY') }}
        </div>

        <div class="cz2__modal-popup__buttons">
            <btn
                primary
                narrow
                @click="close"
            >
                {{ $t('EXIT_MODAL_PRIMARY') }}
            </btn>

            <btn
                secondary
                narrow
                @click="exitToHome"
                class="cz2__btn--primary-cta"
            >
                {{ $t('EXIT_MODAL_SECONDARY') }}
            </btn>
        </div>
    </alert-modal>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__exit-modal {
            .cz2__modal-popup__copy {
                margin-bottom: 24px;
            }

            .cz2__modal-popup__buttons {
                padding-bottom: 8px;
                width: 100%;
                display: flex;
                flex-direction: column;
                gap: 10px;

                .cz2__btn {
                    height: 40px;
                    font-size: 16px;

                    &:focus {
                        &:before {
                            // Prevent focus styles from showing unwanted scrollbars
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
            }
        }
    }
</style>

<script>
    import AlertModal from './ui/AlertModal.vue';

    import Btn from './ui/Btn.vue';

    export default {
        components: {
            AlertModal,
            Btn,
        },

        computed: {
            globalSettings() {
                return this.$store.state.customizer.globalSettings?.blueprint?.custom;
            },

            funkoUrl() {
                return this.globalSettings?.['fun-site-url'] ?? 'https://www.funko.com/';
            },
        },

        methods: {
            close() {
                this.$store.dispatch('showExitModal', false);
            },

            exitToHome() {
                window.location.href = this.funkoUrl;
            },
        },
    };
</script>
